import { Component, OnInit, Input } from '@angular/core';
import { Subject, Observable } from 'rxjs';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  @Input()openModal: boolean = false;

  dialogTitle: string = "";
  dialogTextLine1: string = "";
  dialogTextLine2: string = '';
  cancelButton: string = null;
  onDialogDone: Subject<boolean> = null;
  okCloseButtonClick(ok: boolean) {
    if (this.onDialogDone) {
      this.openModal = false;
      this.onDialogDone.next(ok);
    }
  }
  confirm(msg1: string, msg2: string, title: string, cancelButton: boolean = false): Observable<boolean> {
    this.dialogTitle = title;
    this.dialogTextLine1 = msg1;
    this.dialogTextLine2 = msg2;
    this.openModal = true;
    this.onDialogDone = new Subject<boolean>();

    this.cancelButton = cancelButton ? "Cancel" : null;
    return this.onDialogDone.asObservable();
  }
}
